<template>
  <div class="w-full  ">
    <div class="mt-10 flex flex-row items-center justify-between">
      <div class="text-black text-lg font-semibold ">
        {{ GET_SLIDE.name }}
      </div>
      <counter :endTime="GET_SLIDE.minutes * 60" />
    </div>
    <div
      class="description-container text-base text-black whitespace-pre-line mt-8"
      v-html="slideDescription"
    ></div>
    <custom-button
      @click="UPDATE_SLIDE_PROGRESS"
      class="w-72 h-11 mt-10"
      :text="'Tafel abschließen'"
      :bgColor="'bg-primary'"
      :textColor="'text-white'"
      :id="'text-read-button'"
    />
  </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import sanitizeHtml from "sanitize-html";
import { useStore } from "vuex";
import Counter from "../../../../components/helper/Counter.vue";
import CustomButton from "../../../../components/input/CustomButton.vue";
import { SLIDE_TYPES, STORE_TYPES } from "../../../../store/types";

export default defineComponent({
  components: { CustomButton, Counter },
  name: "FreeText",
  setup() {
    const store = useStore();
    /**
     *  State
     */
    const state = reactive({});
    /**
     *  Functions
     */
function UPDATE_SLIDE_PROGRESS() {
  // ← DEBUGGING
  console.log('🔍 Was steht in GET_SLIDE?', GET_SLIDE.value);
  console.log('🔍 Slide ID im Store:', GET_SLIDE.value.id);
  console.log('🔍 Slide Name im Store:', GET_SLIDE.value.name);
  
  // Was sieht die User wirklich?
  console.log('🔍 Angezeigte Slide im Template:', '{{ GET_SLIDE.name }}');
  
  store.dispatch(
    `${STORE_TYPES.SLIDES}/${SLIDE_TYPES.UPDATE_SLIDE_PROGRESS}`,
    {
      watchTime: 0,
      slide: GET_SLIDE.value,
      isFinished: true,
    }
  );
}
    /**
     *  Computed
     */
    const GET_SLIDE = computed(
      () => store.getters[`${STORE_TYPES.SLIDES}/${SLIDE_TYPES.GET_SLIDE}`]
    );

    const slideDescription = computed(() => {
      return sanitizeHtml(GET_SLIDE.value.description, {
        allowedAttributes: {
          ...sanitizeHtml.defaults.allowedAttributes,
          p: ["style"],
          h1: ["style"],
          h2: ["style"],
          h3: ["style"],
          h4: ["style"],
        },
      });
    });
    /**
     *  Created
     */

    return {
      state,
      UPDATE_SLIDE_PROGRESS,
      GET_SLIDE,
      slideDescription,
    };
  },
});
</script>

<style>
.description-container > * + * {
  margin-top: 0.75em;
}

.description-container h1 {
  font-size: 2em;
  font-weight: bold;
  line-height: initial;
}

.description-container h2 {
  font-size: 1.5em;
  font-weight: bold;
  line-height: initial;
}

.description-container h3 {
  font-size: 1.3em;
  font-weight: bold;
  line-height: initial;
}

.description-container h4 {
  font-size: 1em;
  font-weight: bold;
  line-height: initial;
}

.description-container ul {
  padding: 0 2rem;
  list-style-type: disc;
}

.description-container ul ul {
  padding: 0 2rem;
  list-style-type: circle;
}

.description-container ul ul ul {
  padding: 0 2rem;
  list-style-type: square;
}

.description-container ol {
  padding: 0 2rem;
  list-style-type: decimal;
}

.description-container ol ol {
  padding: 0 2rem;
  list-style-type: lower-latin;
}

.description-container ol ol ol {
  padding: 0 2rem;
  list-style-type: lower-roman;
}
</style>
